<template>
<div class="upcoming">

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
            <van-sticky :offset-top="offsetTop">
                <div class="bitTab">
                    <van-tabs v-model="bidActive" @change="changeBid" shrink>
                        <van-tab v-for="(item,index) in bid_typeList" :key="'bid_typeList'+index" :title="item.name">
                        </van-tab>
                    </van-tabs>
                    <div class="total" ref="total" @click="scCilck()">
                        <span>{{ total }}</span>
                        <AuctionFilter ref="filter-com" @search="search" :type="2" />
                    </div>
                </div>

            </van-sticky>
            <template v-if="loading && !list.length">
                <div class="item" v-for="n in 3" :key="'loading-' + n">
                    <div class="item-type-wrapper">
                        <div class="item-type">
                            <van-skeleton class="vs-type" title />
                        </div>
                    </div>
                    <div class="item-content">
                        <van-skeleton class="vs-title" title avatar />
                        <van-skeleton class="vs-img" title />
                        <van-skeleton class="vs-bottom" title />
                    </div>
                </div>
            </template>
            <div class="item" v-for="(p, index) in renderList" :key="index">
                <div class="item-type-wrapper">
                    <van-sticky :offset-top="typeOffsetTop">
                        <div class="item-type">
                            <div class="item-type-text">{{ p.label_date_show }}</div>
                            <div class="item-type-desc" v-if="p.label_date_show && p.label_date_show !== '推荐'">
                                {{ p.label_month_show }}
                            </div>
                        </div>
                    </van-sticky>
                </div>
                <div class="item-content-wrapper">
                    <div class="item-content" v-for="(item,index) in p.list" @click="toDetail(item,index)" :key="item.source_code">
                        <!-- <div class="com" @click.stop="toComDetail(item)">
                            <van-image :src="item.organ_cover" lazy-load class="com-avatar" />
                            <div class="com-name">{{ item.organ_name }} {{ item.city }}</div>
                        </div> -->
                        <div class="img">
                            <div class="aucStatusBox" :style="(item.bid_type==1||item.bid_type==2)&&(item.bid_status==2||item.live_status==2||item.bid_status==4)?'padding-left:0':''">
                                <span class="aucLive" v-if="item.bid_type==1">
                                    <template v-if="item.bid_status==2">
                                        <lottie class="liveIconSty" :options="heartOptions2" :height="0.7" :width="0.7" />
                                    </template>
                                    <img class="pauseIcon"  v-if="item.bid_status== 4" src="../../../assets/img/pause_icon.png" alt="">
                                    {{item.bid_status_name}}
                                </span>
                                <span class="aucLive" v-if="item.bid_type==2">
                                    <template v-if="item.bid_status==2">
                                        <div class="canpaiBtnIcon"></div>
                                    </template>
                                    {{item.bid_status_name}}
                                </span>
                                <span class="aucLive" v-if="item.bid_status==3&&item.total_price!=''">
                                    成交额：{{item.currency}}{{item.total_price}}{{item.price_unit}}
                                </span>
                                <span class="aucLive" v-else-if="item.bid_status==3">
                                    已结拍
                                </span>
                                <span class="aucLive" v-else-if="item.bid_type==0">
                                    {{ item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '', }}
                                </span>
                            </div>
                            <div class="img-main">
                                <van-image class="poster" lazy-load :src="item.cover_pic" />
                                <div class="mask">

                                    <van-image @click.stop="toComDetail(item,k)" :src="item.organ_cover" lazy-load class="com-avatar" />
                                    <div @click.stop="toComDetail(item,k)" class="com-name">{{ item.organ_name }} {{ item.city }}</div>
                                    <div class="bidBtn" v-if="item.bid_type!=0&&(item.bid_status==1||item.bid_status==2)">

                                        <lottie class="svg" :options="heartOptions3" :height="1.2" :width="1.2" />
                                        <span>点击参拍</span>
                                    </div>
                                </div>
                                <!-- <div class="hot" v-if="item.watch_num">
                                    <img src="../../../assets/img/preview/hot.png" alt="">
                                    <span>{{ item.watch_num }}</span>
                                </div> -->
                            </div>
                            <div v-if="item.type === 2" class="img-level">
                                <div class="img-level-1"></div>
                                <div class="img-level-2"></div>
                            </div>
                        </div>
                        <div class="info">
                            <div class="info-title">
                                <div class="title">{{ item.name }}</div>
                            </div>
                            <div class="info-tags">
                                <template v-for="(e,index) in item.label_new">

                                    <template v-if="e.name=='同步拍'">
                                        <img :key="'tag'+index" class="bidIcon" src="@/assets/img/bid_type_r.png" alt="">
                                    </template>
                                    <template v-else-if="e.name=='限时拍'">
                                        <img :key="'tag'+index" class="bidIcon" src="@/assets/img/bid_type_b.png" alt="">
                                    </template>
                                    <template v-else-if="e.style==1">
                                        <div :key="'tag'+index" class="tag tagStyle">
                                            {{e.name}}
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div :key="'tag'+index" class="tag">
                                            {{e.name}}
                                        </div>
                                    </template>

                                </template>
                                <!-- <img class="bidIcon" v-if="item.bid_type>1" src="@/assets/img/bid_type_b.png" alt="">
                                <img class="bidIcon" v-if="item.bid_type==1" src="@/assets/img/bid_type_r.png" alt="">
                                <template v-if="item.have_live">
                                    <div class="tag living" v-if="item.live_status === 2 && item.live_status_text">
                                        <lottie :options="heartOptions" :height="1" :width="1"></lottie>
                                        <span>{{ item.live_status_text }}</span>
                                    </div>
                                    <div class="tag" v-if="item.live_status_text && item.live_status !== 2">
                                        {{ item.live_status_text }}
                                    </div>
                                </template>
                                <div class="tag" v-if="item.online_auction === 1">{{
                                            item.online_auction_text
                                        }}
                                </div> -->
                            </div>
                            <div class="info-bottom">
                                <div class="left">
                                    <div class="time">{{ item.auction_date }}</div>
                                    <div class="count">拍品 {{ item.total }}</div>
                                </div>
                                <div class="right">
                                    <img v-if="item.isFocus === 0" @click.stop="focusOn(item)" src="../../../assets/img/preview/like.png" alt="">
                                    <img v-else @click.stop="focusOn(item)" src="../../../assets/img/preview/like-active.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <EmptyPage v-if="page === 1 && !list.length && !loading" />

            <template #finished v-if="list.length">
                <div class="noMore">
                    <span>我是有底线的</span>
                </div>
            </template>
        </van-list>
    </van-pull-refresh>
</div>
</template>

<script>
import AuctionFilter from '@/views/previewNew/component/AuctionFilter.vue'
import barMixin from '@/views/previewNew/component/bar-mixin'
import EmptyPage from '@/components/empty/emptyPage.vue'
import {
    focusOn,
    getAuctionList
} from '@/api/preview'
import lottie from '@/components/common/lottie.vue'
import liveIcon from '@/assets/img/live_icon.json'
import liveIcon3 from '@/assets/img/live_icon_3.json'
import {
    gotoLogin,
    scMdFunc
} from '@/assets/js/scData'
import {
    getWXConfig
} from '@/assets/js/weixinShare'
export default {
    name: 'upcoming',
    components: {
        lottie,
        EmptyPage,
        AuctionFilter
    },
    mixins: [barMixin],
    data() {
        return {
            list: [],
            bidActive: 0,
            bid_typeList: [],
            renderList: [],
            shareMessage: {},
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: '加载中',
            params: {},
            from: '',
            isLogin: false,
            specialDate: "",
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true
            },
            heartOptions3: {
                animationData: liveIcon3,
                loop: true,
                autoplay: true
            },
            ads: {}
        }
    },
    mounted() {
        if (this.$route.query.bid_type) {
            this.bidActive = Number(this.$route.query.bid_type)
        }
        this.onLoad();
    },
    methods: {
        scCilck() {
            scMdFunc('allClick', {
                cur_page: '19',
                cur_moudle: '19-0',
                cur_button: '19-0-1',
            })
        },
        changeBid() {
            this.page = 1
            this.from = ''
            this.specialDate = ""
            this.finished = false
            this.refreshing = true
            this.loading = true
            scMdFunc('allClick', {
                cur_page: '19',
                cur_moudle: '19-0',
                cur_button: '19-0-' + Number(this.bidActive + 2),
            })
            this.onLoad();
        },
        onLoad() {
            let that = this;
            getAuctionList({
                bid_type: this.bidActive,
                special_type: 2,
                page: this.page,
                from: Number(this.from),
                label_date: this.specialDate,
                ...this.params
            }).then(res => {
                if (res.code === 0) {
                    if (this.refreshing) {
                        this.list = []
                        this.renderList = []
                        this.refreshing = false
                    }

                    res.data.list.forEach((item => {
                        if (item.isAD) {
                            this.ads[item.source_code] = true
                        }
                        that.specialDate = item.special_date
                    }))

                    this.list.push(...res.data.list)
                    this.from = res.data.list.length

                    let n = -1
                    this.list.forEach((item) => {
                        if (item.label_date_show || item.label_month_show) {
                            n++
                            this.renderList[n] = {
                                label_date_show: item.label_date_show,
                                label_month_show: item.label_month_show,
                                list: []
                            }
                        } else {
                            if (!this.renderList[n]) {
                                this.renderList[n] = {}
                            }
                        }
                        if (item.isAD || (!item.isAD && !this.ads[item.source_code])) {
                            this.renderList[n].list.push(item)
                        }
                    })
                    this.renderList = this.renderList.filter(i => i.list.length)
                    this.total = res.data.special_total
                    this.isLogin = res.data.isLogin
                    this.bid_typeList = res.data.bid_type
                    this.shareMessage = res.data.shareMessage
                    this.setWxConfig();
                    this.loading = false

                    this.page++

                    if (!res.data.morePage) {
                        this.finished = true
                    }
                }
            })
        },
        onRefresh() {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
            this.page = 1
            this.from = ''
            this.specialDate = ''
            this.finished = false
            this.loading = true
            this.onLoad()
        },
        setWxConfig() {
            if (this.shareMessage) {
                document.title = this.shareMessage.title;
                window.AFedWxShareData = {
                    title: this.shareMessage.title,
                    imgUrl: this.shareMessage.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
                    desc: this.shareMessage.desc || '',
                    link: this.shareMessage.url
                }
                getWXConfig(window.AFedWxShareData)
            }

        },
        search(params) {
            if (params) {
                this.params = params
            } else {
                this.params = {}
            }
            this.$refs['filter-com'].saveTemp()
            this.$router.push({
                name: 'previewSearchUpcoming',
                params
            })
            // this.list = []
            // this.onRefresh()
        },
        focusOn(item) {
            if (!this.isLogin) {
                gotoLogin()
                return
            }
            if (item.isFocus) {
                let params = {
                    special_type: item.type,
                    code: item.source_code,
                    action: 2
                }
                focusOn(params).then(res => {
                    if (res.code === 0) {
                        item.isFocus = 0
                    }
                })
            } else {
                let params = {
                    special_type: item.type,
                    code: item.source_code,
                    action: 1
                }
                focusOn(params).then(res => {
                    if (res.code === 0) {
                        this.$toast('关注成功')
                        item.isFocus = 1
                    }
                })
            }
        },
        toDetail(item, i) {
            if (item.type == 1) {

                scMdFunc('allClick', {
                    cur_page: '19',
                    cur_moudle: '19-1',
                    cur_button: '19-1-' + Number(i + 1),
                    auction_specia_performance_id_pk: item.special_id,
                    auction_specia_performance_id: item.special_code,
                    the_auction_id_pk: item.session_id,
                    the_auction_id: item.session_code,
                    auction_company_id: item.organ_id,
                    auction_company_code: item.organ_code,
                    auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                    auction_type: item.bid_type
                })
            } else {
                scMdFunc('allClick', {
                    cur_page: '19',
                    cur_moudle: '19-1',
                    cur_button: '19-1-' + Number(i + 1),
                    the_auction_id_pk: item.session_id,
                    the_auction_id: item.session_code,
                    auction_company_id: item.organ_id,
                    auction_company_code: item.organ_code,
                    auction_state: item.status == 1 ? '待拍卖' : item.status == 2 ? '预展中' : item.status == 3 ? '待预展' : item.status == 4 ? '拍卖中' : item.status == 5 ? '已结拍' : '',
                    auction_type: item.bid_type,
                })

            }
            if (item.type === 1) {
                this.$router.push({
                    name: 'search_special',
                    params: {
                        specialCode: item.source_code
                    }
                })
            } else {
                this.$router.push({
                    name: 'session',
                    params: {
                        sessionCode: item.source_code
                    }
                })
            }
        },
        toComDetail(item) {
            this.$router.push({
                name: 'meetinglist',
                params: {
                    organCode: item.organ_code
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "common";

.upcoming {
    .bitTab {
        position: relative;

        .total {
            position: absolute;
            z-index: 106;
            right: 0;
            top: 0.3rem;
        }

        /deep/ .van-tabs {
            width: 100%;

            .van-tabs__wrap {
                height: auto !important;
                border-bottom: 0 !important;
                position: fixed;
                left: 0;
                //top: 5.725rem;
                width: 100%;
                z-index: 100;

                .van-tabs__nav {
                    padding-left: .2rem;
                    padding-right: .2rem;
                    padding-bottom: 0.5rem;
                    padding-top: 0.5rem;

                    .van-tab {
                        flex: none;
                        margin: 0 .6rem;
                        padding: 0;

                        .van-tab__text {
                            font-size: 0.6rem !important;
                            font-family: SF Pro-Regular, SF Pro;
                            font-weight: 400;
                            color: #6B6C6C;
                        }

                        &.van-tab--active {
                            background: #F1F1F1;
                            border-radius: 0.5rem;
                            padding: 0.3rem 0.5rem;

                            .van-tab__text {
                                font-size: 0.7rem !important;
                                font-weight: bold;
                                color: #000000;
                            }
                        }
                    }

                    .van-tabs__line {
                        display: none;
                    }
                }
            }

            .van-tabs__content {
                padding: 2rem .8rem .8rem;
                position: relative;
                padding-bottom: calc(.8rem + constant(safe-area-inset-bottom));
                padding-bottom: calc(.8rem + env(safe-area-inset-bottom));

                &::before {
                    position: absolute;
                    left: 0;
                    top: -2rem;
                    display: block;
                    content: '';
                    width: 100%;
                    height: 8.9rem;
                    background: linear-gradient(180deg, #FFFFFF 63%, rgba(255, 255, 255, 0) 97%);
                    z-index: -1;
                }
            }
        }
    }

    .bidIcon {
        height: 16px;
        margin-right: 0.5rem;
    }

    .item {
        display: flex;
        align-items: flex-start;

        .item-type-wrapper {
            /deep/ .van-sticky--fixed {
                width: 2.65rem;

                .item-type {
                    margin-left: auto;
                }
            }

            position: relative;
            width: 1.85rem;
            margin-right: .8rem;

            .item-type {
                width: 1.85rem;
                font-size: 0.9rem;
                font-family: DINPro-Black, DINPro;
                font-weight: 900;
                color: #000000;
                line-height: 0.9rem;
                white-space: nowrap;
                text-align: center;
                background: #f7f7f7;
                position: relative;
                z-index: 100;
                margin-top: .5rem;

                &-text {
                    margin-bottom: .5rem;
                }

                &-desc {
                    font-size: 0.7rem;
                    font-family: PingFang SC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #949596;
                }

                .vs-type {
                    padding: 0;

                    .van-skeleton__content {
                        width: 2rem;
                        height: 2.2rem;

                        .van-skeleton__title {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }

        .item-content-wrapper {
            width: calc(100% - 2.65rem);
        }

        .item-content {
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, 0.03);
            border-radius: 1.2rem;
            padding: .65rem .5rem 1rem;
            margin-bottom: .8rem;

            .vs-title {
                padding: 0 .1rem;

                .van-skeleton__avatar {
                    width: 1.6rem;
                    height: 1.6rem;
                    margin-right: .4rem;
                }

                .van-skeleton__content {
                    width: 4.2rem;
                    height: 1.6rem;
                    padding: 0;

                    .van-skeleton__title {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .vs-img {
                padding: 0;
                height: 9.6rem;
                border-radius: 1rem;
                margin: .5rem 0;
                overflow: hidden;

                .van-skeleton__title {
                    width: 100%;
                    height: 100%;
                }
            }

            .vs-bottom {
                padding: 0 .1rem;
                width: 9.86rem;
                height: 2rem;

                .van-skeleton__title {
                    width: 100%;
                    height: 100%;
                }
            }

            .com {
                width: 100%;
                height: 1.5rem;
                padding: 0 .1rem;
                display: flex;
                align-items: center;

                &-avatar {
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 50%;
                    margin-right: .4rem;
                    overflow: hidden;
                }

                &-name {
                    width: calc(100% - 2.25rem);
                    height: 1.25rem;
                    font-size: 0.73rem;
                    font-family: SF Pro-Expanded Heavy, SF Pro;
                    font-weight: normal;
                    color: #000000;
                    line-height: 1.24rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            .img {
                width: 100%;
                margin: .5rem 0 0;
                position: relative;

                .aucStatusBox {
                    position: absolute;
                    left: 0.5rem;
                    top: 0.5rem;
                    padding: 0 0.4rem;
                    border-radius: 0.7rem;
                    background-color: #FCFBF9;
                    font-size: 0;
                    z-index: 5;

                    .aucLive {
                        color: #000;
                        font-size: .6rem;
                        font-weight: 600;
                        display: inline-block;
                        line-height: 1rem;

                        img {
                            height: .5rem;
                            width: .45rem;
                        }

                        .canpaiBtnIcon {
                            width: 1.3rem;
                            display: inline-block;
                            vertical-align: middle;
                            background-color: #F6344B;
                            background-image: url('../../../assets/img/canpaiBtn_icon.png');
                            background-repeat: no-repeat;
                            background-position: 50% 50%;
                            background-size: 60% 60%;
                            height: 1.3rem;
                            border-radius: 2rem;
                        }
                        .pauseIcon{
                            height: 0.9rem;
                            width: 0.9rem;
                            margin-left: 1px;
                        }
                    }
                }

                .img-main {
                    width: 100%;
                    height: 8.2rem;
                    border-radius: 1rem;
                    overflow: hidden;
                    position: relative;

                    .poster {
                        width: 100%;
                        height: 100%;
                    }

                    .mask {
                        width: 100%;
                        padding: 0.58rem 0.58rem 0.29rem 0.58rem;
                        background: rgba(0, 0, 0, 0.3);
                        box-sizing: border-box;
                        position: absolute;
                        left: 0;
                        bottom: 0;

                        .bidBtn {
                            position: absolute;
                            right: 0.3rem;
                            top: 0.4rem;

                            height: 1.44rem;
                            line-height: 1.44rem;
                            padding: 0 0.4rem;
                            font-weight: 500;
                            font-size: 0.7rem;
                            background: #009B5F;
                            border-radius: 1rem;
                            color: #FFFFFF;

                            .svg {
                                display: inline-block;
                                vertical-align: middle;
                            }

                        }

                        .com {
                            width: 100%;
                            height: 1.5rem;
                            padding: 0 .1rem;
                            display: flex;
                            align-items: center;

                            &-avatar {
                                width: 1.41rem;
                                height: 1.41rem;
                                border-radius: 50%;
                                margin-right: 0.23rem;
                                vertical-align: top;
                                overflow: hidden;
                            }

                            &-name {
                                width: calc(70% - 2.25rem);
                                height: 1.25rem;
                                font-size: .75rem;
                                display: inline-block;
                                font-family: SF Pro-Expanded Heavy, SF Pro;
                                font-weight: 600;
                                color: #fff;
                                line-height: 1.24rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }

                    .status {
                        position: absolute;
                        bottom: .5rem;
                        left: .6rem;
                        display: flex;
                        align-items: center;

                        img {
                            width: 0.8rem;
                            height: .8rem;
                            margin-right: .3rem;
                        }

                        span {
                            height: 0.55rem;
                            font-size: 0.55rem;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #F64F4F;
                            line-height: 0.55rem;
                        }
                    }

                    .hot {
                        position: absolute;
                        bottom: .4rem;
                        right: .45rem;
                        display: flex;
                        align-items: center;
                        height: 1.2rem;
                        background: rgba(130, 133, 139, 0.5);
                        border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
                        padding: 0 .5rem;

                        img {
                            width: 0.53rem;
                            height: .61rem;
                            margin-right: .25rem;
                        }

                        span {
                            height: 0.6rem;
                            font-size: 0.6rem;
                            font-family: SF Pro-Regular, SF Pro;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 0.6rem;
                        }
                    }
                }

                .img-level {
                    &-1 {
                        width: calc(100% - 1rem);
                        height: 7.9rem;
                        background: rgba(169, 169, 169, 0.5);
                        border-radius: 1rem;
                        margin: -7.6rem auto 0;
                    }

                    &-2 {
                        width: calc(100% - 2rem);
                        height: 8.2rem;
                        margin: -7.9rem auto .3rem;
                        background: rgba(169, 169, 169, 0.3);
                        border-radius: 1rem;
                    }
                }
            }

            .info {
                padding: 0 .1rem;
                margin-top: .6rem;

                &-title {
                    display: flex;
                    align-items: center;

                    .tag {
                        width: 3rem;
                        height: 1rem;
                        background: #4A82D6;
                        border-radius: 0.1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.5rem;
                        font-family: SF Pro-Regular, SF Pro;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 0.5rem;
                        margin-right: .5rem;
                    }

                    .title {
                        flex: 1;
                        height: 0.7rem;
                        font-size: 0.7rem;
                        font-family: SF Pro-Medium, SF Pro;
                        font-weight: 500;
                        color: #000000;
                        line-height: 0.8rem;
                        letter-spacing: 1px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                &-tags {
                    margin: .2rem 0 .4rem;
                    display: flex;

                    .tag {
                        padding: 0 0.2rem;
                        height: 0.8rem;
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        background: rgba(0, 0, 0, 0.05);
                        display: flex;
                        align-items: center;
                        margin-right: .5rem;
                        font-size: 0.5rem;
                        font-family: SF Pro-Regular, SF Pro;
                        font-weight: 400;
                        color: #6B6C6C;

                        &.living {
                            color: #F64F4F;
                            border-color: #D4101C;
                            display: flex;
                            align-items: center;
                        }
                    }

                    .tagStyle {
                        color: #FFFFFF;
                        background: linear-gradient(87deg, #FB9C57 0%, #F22C2C 100%), rgba(0, 155, 95, 0.05);
                    }
                }

                &-bottom {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .left {
                        height: 0.6rem;
                        font-size: 0.6rem;
                        font-family: SF Pro-Regular, SF Pro;
                        font-weight: 400;
                        color: #5B5E63;
                        line-height: 0.65rem;
                        display: flex;
                        align-items: center;
                        width: 90%;

                        .time {
                            margin-right: .5rem;
                            max-width: 66%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }
                    }

                    .right {
                        img {
                            width: .8rem;
                            height: .8rem;
                        }
                    }
                }
            }
        }
    }

    .noMore {
        margin-top: 1.2rem;
        text-align: center;
        font-size: 0.65rem;
        color: #cccccc;
        padding-bottom: 2rem;

        span {
            position: relative;
            display: inline-block;
            padding: 0 0.5rem;

            &::before,
            &::after {
                content: "";
                position: absolute;
                width: 2.5rem;
                height: 0.05rem;
                background: #dddee3;
                top: 50%;
                transform: translateY(-50%);
            }

            &::before {
                left: 100%;
            }

            &::after {
                right: 100%;
            }
        }
    }
}
</style>
